import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, VerticalLineIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../svg/svgIcons";
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { Checkbox } from 'primereact/checkbox';
import { useMachineCards } from '../../utils/useMachineCards';
import { useMaintenanceTemplates } from '../../utils/useMaintenanceTemplates';
import { uiT as t } from '../../utils/uiTranslate';

function emptyFormValues(sourceMachineId = '') {
    return {
        machine_type_id: '',
        initial_date: '',
        machine_id: '',
        maintenance_types: [],
        copy_records: false,
        maintenance_template_id: '',
        source_machine_id: sourceMachineId ? String(sourceMachineId) : '',
    };
}

export default function MaintenanceCardAdd({machine=null}) {
    
    const [state,dispatch] = useContext(DatabaseContext);
    const { machineCards } = useMachineCards();
    const { maintenanceTemplates } = useMaintenanceTemplates();
    const {user} = useContext(AuthContext);
    const {toast,openFavoriteDialog,setFastView,setDialogText,setVisible} = useContext(UtilContext);
    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);
    const sourceMachine = machine?.id ? machine : null;

    const [formType,setFormType] = useState("add");

    const [maintenanceTypeMarked, setMaitenanceTypeMarked] = useState({});
    const [markUnmark, setMarkUnmarked] = useState(true);

    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add maintenance"))?false:true);

    const sourceMachineCards = useMemo(() => {
        if (!sourceMachine?.id) return [];
        if (Array.isArray(sourceMachine.machine_card) && sourceMachine.machine_card.length > 0) {
            return sourceMachine.machine_card;
        }
        return (machineCards ?? []).find((row) => Number(row.id) === Number(sourceMachine.id))?.machine_card ?? [];
    }, [sourceMachine, machineCards]);

    const buildMarkedTypesFromSource = useCallback(() => {
        const marked = {};
        sourceMachineCards.forEach((item) => {
            const typeId = item?.maintenance_type_id;
            if (typeId) marked[typeId] = true;
        });
        return marked;
    }, [sourceMachineCards]);

    function addNewMaintenanceType(){
        dispatch({type:'create_new_tab',name: t('MaintenanceCardAdd.Text.NOVA_KARTA_STROJA'), translationKey: 'MaintenanceCardAdd.Text.NOVA_KARTA_STROJA', legacyLabel: t('MaintenanceCardAdd.Text.NOVA_KARTA_STROJA'),page:'MaintenanceCardAdd',props:{machine: null,type:'add'},mask:'mntn016'})
    }
    function copyMaintenanceType(){
        dispatch({type:'create_new_tab',name: t('MaintenanceCardAdd.Text.NOVA_KARTA_STROJA'), translationKey: 'MaintenanceCardAdd.Text.NOVA_KARTA_STROJA', legacyLabel: t('MaintenanceCardAdd.Text.NOVA_KARTA_STROJA'),page:'MaintenanceCardAdd',props:{machine: sourceMachine,type:'add'},mask:'mntn016'})
    }

    function changeTemplate(template_id){
        const maintenanceTypeMarked = {};
        (maintenanceTemplates ?? [])
            .filter((template) => template.id == template_id)[0]
            ?.template_records
            ?.forEach((item) => {
                maintenanceTypeMarked[item.maintenance_type_id] = true;
            });
        setMaitenanceTypeMarked(maintenanceTypeMarked);
        formik.setFieldValue("maintenance_template_id",template_id);
        formik.setFieldValue('copy_records', false);
        formik.setFieldValue('source_machine_id', '');
    }

    function copyFromMachine(value){
        if (value && sourceMachine?.id) {
            if (Object.keys(maintenanceTypeMarked).filter((k) => maintenanceTypeMarked[k]).length === 0) {
                setMaitenanceTypeMarked(buildMarkedTypesFromSource());
            }
            formik.setFieldValue('source_machine_id', String(sourceMachine.id));
        } else {
            formik.setFieldValue('source_machine_id', '');
        }
        formik.setFieldValue('copy_records', !!value);
        if (value) {
            formik.setFieldValue('maintenance_template_id', '');
        }
    }

    function changeMarkings(value) {
        const updated = {};
        for (let key in maintenanceTypeMarked) {
            updated[key] = value;
        }
        setMaitenanceTypeMarked(updated);
    }

    function setMask(item,value){
        setMaitenanceTypeMarked(prev => ({
            ...prev,
            [item]: value
        }));
    }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = '*Povinné';
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues: sourceMachine
            ? { ...emptyFormValues(sourceMachine.id), copy_records: true }
            : emptyFormValues(),
        enableReinitialize:false,
        validate,
        onSubmit: values => {
            const selectedTypeIds = Object.keys(maintenanceTypeMarked).filter((k) => maintenanceTypeMarked[k]);
            if (!values.machine_id) {
                toast?.current?.show({ severity: 'warn', summary: 'Upozornenie', detail: t('MaintenanceCardAdd.Text.Vyberte_stroj_pre_novu_kartu'), life: 3500 });
                return;
            }
            if (selectedTypeIds.length === 0) {
                toast?.current?.show({ severity: 'warn', summary: 'Upozornenie', detail: t('MaintenanceCardAdd.Text.Oznacte_aspon_jeden_typ_planovaneho_ukonu'), life: 3500 });
                return;
            }
            if (!values.initial_date) {
                toast?.current?.show({ severity: 'warn', summary: 'Upozornenie', detail: t('MaintenanceCardAdd.Text.Vyplnte_datum_prvotneho_vykonania'), life: 3500 });
                return;
            }
            setDialogText(t('Common.Saving'));
            setVisible(true);
            let formData = new FormData();
            let maintenance_types = selectedTypeIds;
            for (var i = 0; i < maintenance_types.length; i++) {
                formData.append('maintenance_types[]', maintenance_types[i]);
            }
            //console.log(maintenanceTypeMarked);
            for (let value in values) {
                if (value === 'maintenance_types') continue;
                if (value === 'source_machine_id' && !values.copy_records) continue;
                formData.append(value, values[value] != null ? values[value] : '');
            }
            if (values.copy_records && sourceMachine?.id) {
                formData.set('source_machine_id', String(sourceMachine.id));
                formData.set('copy_records', 'true');
            }
            /*for (var pair of formData.entries()) {
                console.log(pair[0]+ ', ' + pair[1]); 
            }*/
            if(formType=="add"){
                postRequest('/api/machine_cards/card', formData,true)
                .then((response) => {
                    if (Number(response?.status) >= 400) {
                        throw new Error(response?.message || t('MaintenanceCardAdd.Text.Ulozenie_zlyhalo'));
                    }
                    setFormType("edit");
                    getRequest("/api/machine_cards").then((r) => {
                        const list = r?.data ?? [];
                        if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                        const created = list.find((row) => Number(row.id) === Number(values.machine_id));
                        if (created) formik.setValues({ ...emptyFormValues(), ...created });
                        setVisible(false);
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    }).catch(() => {});
                }).catch((reason) => {
                    setVisible(false);
                    const msg = reason?.message || t('Common.Toast.ActionFailedDetail');
                    if (!navigator.onLine) {
                        alert(t('Common.OfflineQueuedAccent'));
                    } else {
                        alert(msg);
                    }
                })
            }
        },
    });

    useEffect(() => {
        if (!sourceMachine?.id) return;
        setMaitenanceTypeMarked(buildMarkedTypesFromSource());
        formik.setFieldValue('copy_records', true);
        formik.setFieldValue('source_machine_id', String(sourceMachine.id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sourceMachine?.id, buildMarkedTypesFromSource]);

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewMaintenanceType()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyMaintenanceType()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => openFavoriteDialog(t('MaintenanceCardAdd.Text.NOVA_KARTA_STROJA'),"MaintenanceCardAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("MaintenanceCardAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col overflow-x min-h-[calc(100vh-177px)] bg-gray-100">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-white rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('MaintenanceCardAdd.Text.NOVA_KARTA_STROJA')}</h1>
                {sourceMachine?.name && (
                    <p className="text-sm text-gray-600 mt-2">
                        Kopírovanie typov pl. úkonov zo stroja: <strong>{sourceMachine.name}</strong>
                        <span className="block text-xs mt-1">{t('Ui.R67.Historia_vykonania_zaznamy_sa_nekopiruje_Datum_prvotneho_vyk')}</span>
                    </p>
                )}
                <div>
                        <label
                            htmlFor="machine_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.MachineName')}</label>
                        <select 
                        required
                        name='machine_id'
                        onChange={formik.handleChange} value={formik.values.machine_id} 
                        className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                          <option value="">{t('ServiceTaskDetail.SelectMachine')}</option>
                          {state.machines.filter(a => !(machineCards ?? []).map((b) => b.id).includes(a.id)).map((machine) => (
                            <option key={machine.id} value={machine.id}>{machine.name}</option>
                          ))}
                        </select>
                        </div>
                        {(!sourceMachine) && <div>
                        <label
                            htmlFor="maintenance_template_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Sablona_pre_druh_stroja')}</label>
                        <select 
                        name="maintenance_template_id"
                        onChange={(e) => changeTemplate(e.target.value)} value={formik.values.maintenance_template_id} 
                        className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                          <option value="">{t('TrainingCardAdd.Text.Bez_sablony')}</option>
                          {(maintenanceTemplates ?? []).map((template) => (
                            <option key={template.id} value={template.id}>{template.name}</option>
                            ))}
                        </select>
                        </div>}
                        {(sourceMachine!=null) && <div className="flex align-items-center mt-2">
                            <Checkbox inputId="copy_planned_types" name="copy_records" onChange={(e) => copyFromMachine(e.checked)} checked={!!formik.values.copy_records} />
                            <label htmlFor="copy_planned_types" className="ml-2">{t('Ui.R67.Kopirovat_zodpovedneho_firmu_a_parametre_karty_zo_zdroja_typ')}</label>
                        </div>}
                      {((formik.values.maintenance_template_id && formik.values.maintenance_template_id !== '') || sourceMachine) && <div>
                        <label
                            htmlFor="initial_date"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Datum_prvotneho_vykonania')}</label>
                        <input
                            name='initial_date'
                            type="date" required
                            onChange={formik.handleChange} value={formik.values.initial_date}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                     </div>}
            </div>
            {(formik.values.maintenance_template_id && formik.values.maintenance_template_id !== "" && formik.values.maintenance_template_id !== null) &&  <div className="w-auto p-6 m-4 bg-white rounded-md shadow-md">
                <div className='flex justify-between'>
                    <h1 className="text-3xl font-semibold text-left text-zinc-900">
                   {(maintenanceTemplates ?? []).find((t) => t.id == formik.values.maintenance_template_id)?.name}
                </h1>
                <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
                </div>
                <div className="flex flex-col h-[600px] overflow-y-auto">
                    {((maintenanceTemplates ?? []).find((t) => t.id == formik.values.maintenance_template_id)?.template_records ?? []).slice().sort((a,b) => (a.maintenance_type?.machine_type?.id ?? 0) < (b.maintenance_type?.machine_type?.id ?? 0) ? -1 : 1).map(function(item, index){ 
                        return <div key={index} className="flex flex-row border border-black rounded-md p-2 m-1"> 
                            <Checkbox onChange={(e) => setMask(item.maintenance_type_id,e.checked)} checked={maintenanceTypeMarked[item.maintenance_type_id]}></Checkbox><span className="ml-2">{item.maintenance_type.machine_type.name + " - " + item.maintenance_type.name}</span>
                        </div> ;
                    })} 
                </div>
            </div>}
            {(sourceMachine != null) && (
            <div className="w-auto p-6 m-4 bg-white rounded-md shadow-md">
                <div className='flex justify-between'>
                    <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.Typy_pl_ukonov_na_novej_karte')}</h1>
                <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
                </div>
                <div className="flex flex-col h-[600px] overflow-y-auto">
                    {[...sourceMachineCards].slice().sort((a,b) => (a.maintenance_type?.machine_type?.id ?? 0) < (b.maintenance_type?.machine_type?.id ?? 0) ? -1 : 1).map(function(item, index){ 
                        return <div key={item.id ?? index} className="flex flex-row border border-black rounded-md p-2 m-1"> 
                            <Checkbox onChange={(e) => setMask(item.maintenance_type_id,e.checked)} checked={maintenanceTypeMarked[item.maintenance_type_id]}></Checkbox><span className="ml-2">{item.maintenance_type?.machine_type?.name + " - " + item.maintenance_type?.name}</span>
                        </div>;
                    })} 
                </div>
            </div>
            )}
            </div>
            </div>
            <button type='submit' ref={submitRef}></button>
             </form>
            </div>
            </> 
            );

}